module.exports = __webpack_public_path__ + "static/media/fold_3x.46d5424c.webp";